import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=3b224ff6"
import script from "./Partner.vue?vue&type=script&lang=ts"
export * from "./Partner.vue?vue&type=script&lang=ts"
import style0 from "./Partner.vue?vue&type=style&index=0&id=3b224ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports